import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import {Field} from 'react-final-form';
import color from 'color';

import classNames from 'classnames';

import {Icon, ThemeContext} from '../';

const Checkbox = (props) => {
  const {name, label, rowGap, validatorsArray, cls} = props;
  const formRowClasses = classNames(
    'form__row',
    {
      [`form__row_gap_${rowGap}`]: Boolean(rowGap),
    }
  );

  const composeValidators = (...validators) => (value, allValues) =>
    validators.reduce((error, validator) => error || validator(value, allValues), undefined);

  return (
    <ThemeContext.Consumer>
      {(theme) => {
        const tickStyles = {
          color: theme.primaryColor,
        };
        const inputStyles = {
          ':focus + .checkbox__tick': {
            boxShadow: `0 0 3px 1px ${color(theme.primaryColor).lighten(0.5).hexString()}`,
          },
        };
        const checkboxCls = `checkbox ${cls}`;

        return (
          <Field
            name={name}
            validate={composeValidators(...validatorsArray)}
          >
            {({input, meta}) => (
              <div className={formRowClasses}>
                <div className={checkboxCls}>
                  <span className="checkbox__box">
                    <input style={inputStyles} {...input} className="checkbox__input" type="checkbox" id={name}/>
                    <span className="checkbox__tick" style={tickStyles}>
                      <Icon glyph="check"/>
                    </span>
                    {meta.error && meta.touched &&
                      <span className="form__error">{meta.error}</span>
                    }
                  </span>
                  <label className="checkbox__label" htmlFor={name}>{label}</label>
                </div>
              </div>
            )}
          </Field>
        );
      }}
    </ThemeContext.Consumer>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  validatorsArray: PropTypes.arrayOf(PropTypes.func),
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  rowGap: PropTypes.string,
  cls: PropTypes.string,
};

Checkbox.defaultProps = {
  validatorsArray: [],
  rowGap: 's',
  cls: '',
};

export default Radium(Checkbox);
